import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "./api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (++tries < 8) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-ink-950 text-white">
      <div className="grain" aria-hidden="true" />
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 text-center">
        {status === "checking" && <><Loader2 size={40} className="animate-spin text-gold" /><p className="mt-4 font-oswald text-2xl uppercase tracking-tight">Confirming payment…</p></>}
        {status === "paid" && <>
          <CheckCircle2 size={48} className="text-emerald-400" />
          <h1 className="mt-4 font-oswald text-4xl font-700 uppercase tracking-tighter">You're In!</h1>
          <p className="mt-3 text-zinc-400">Your tickets are ready. Show the QR codes at the door.</p>
          <Link to="/tickets" data-testid="view-tickets" className="mt-8 bg-gold px-8 py-4 font-mono text-[12px] uppercase tracking-[0.25em] text-ink-950">View My Tickets</Link>
        </>}
        {(status === "error" || status === "timeout") && <>
          <XCircle size={44} className="text-red-400" />
          <p className="mt-4 font-oswald text-2xl uppercase tracking-tight">Still processing</p>
          <p className="mt-2 text-zinc-400">If you were charged, your tickets will appear shortly.</p>
          <Link to="/tickets" className="mt-8 border border-white/20 px-8 py-4 font-mono text-[12px] uppercase tracking-[0.25em]">My Tickets</Link>
        </>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-ink-950 text-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 text-center">
        <XCircle size={44} className="text-zinc-500" />
        <h1 className="mt-4 font-oswald text-3xl font-700 uppercase tracking-tighter">Payment Cancelled</h1>
        <Link to="/events" className="mt-8 bg-gold px-8 py-4 font-mono text-[12px] uppercase tracking-[0.25em] text-ink-950">Back to Events</Link>
      </div>
    </div>
  );
}
